import Tabs from "./Tabs";
import self from "../images/YiJu_Miller_self1.jpg"
import "../css/layout.css"

export default function Header() {
  return (
    <div className='header'>
      <div className='header-left'>
        <img src={self} height="64" style={{ verticalAlign: 'top' }} alt="YiJu Miller" />
        <h2 className='signature' style={{ display: 'inline-block', padding: '5px' }}>YiJu Miller</h2>
      </div>
      <div className='header-right'>
        <Tabs />
      </div>
    </div>
  )
}
